import { Tabs, TabsProps } from 'antd';

import styles from './tab.module.scss';

interface TabProps {
  items: {
    key: string;
    label: string;
    children: JSX.Element;
    disabled?: boolean;
  }[];
}

export const Tab = ({ items }: TabProps) => {
  const tabItems: TabsProps['items'] = items.map((item) => ({
    key: item.key,
    label: item.label,
    children: item.children,
    disabled: item.disabled,
  }));

  return <Tabs items={tabItems} className={styles.tabs} />;
};
